<div class="dailogue-view-stmt container-fluid-xxl" [class.my-2]="!isDialogMode" [class.max-1400px]="!isDialogMode">
  @if (isDialogMode) {
    <button #closeButton mat-icon-button [mat-dialog-close]="true" class="dailogue-close-icon">
      <i class="pi pi-times"></i>
    </button>
  }
  @if (formLoading) {
    <div class="kbm-search-loading">
      <i class="pi pi-spinner pi-spin"></i>
      <div class="mt-2 mb-0 text-white">Loading Statement...</div>
    </div>
  }
  @if (isSendingEmail) {
    <div class="kbm-search-loading">
      <i class="pi pi-spinner pi-spin"></i>
      <div class="mt-2 mb-0 text-white">Preparing Email...</div>
    </div>
  }
  <div id="pdfContent">
    <div class="d-flex align-items-center">
      <div class="d-flex justify-content-between w-100">
        <div>
          <p class="mb-0">
            <b>{{ ownerStmt?.ownerName }}</b>
          </p>
          <!--Dr Matt King-->
          <p class="mb-0">
            <b>{{ ownerStmt?.ownerAdrStreet }}</b>
          </p>
          <p class="mb-0">
            <b>{{ ownerStmt?.ownerAdrCity }}</b>
          </p>
        </div>
        <!-- <div class="d-flex justify-content-end">
        <div class="text-end">
          <p class="mb-0">Property : &nbsp;</p>
          <p class="mb-0">Invoice Period : &nbsp;</p>
          <p class="mb-0">Program : &nbsp;</p>
        </div>
        <div>
          <p class="mb-0"><b>{{ownerStmtOjb?.property}}</b></p>
          <p class="mb-0"><b>{{ownerStmtOjb?.invoicePeriod}}</b></p>
          <p class="mb-0"><b>{{ownerStmtOjb?.program}}</b></p>
        </div>
      </div> -->
    </div>
  </div>
  <div class="owner-top-section">
    <div class="info-part">
      <img src="assets/img/header-logo.png" alt="KBM Resorts Logo" class="logo">
      <h1 class="stmt-heading mb-2 mt-3">Owner Statement</h1>
      <p class="owner-place-info">
        <span>{{ ownerStmtOjb?.property }}</span> •
        <span>{{ ownerStmtOjb?.invoicePeriod }}</span> •
        <span>{{ ownerStmtOjb?.program }}</span> •
        <span>Mgmt Comm : {{ (ownerStmtOjb?.propertyManagementCommissionRate || 0) * 100 | number:'1.0-0' }}%</span>
      </p>
    </div>
    <div class="action-part">
      <div #pdfDownload>
        <a (click)="downloadAsPdf($event)" [class.disabled]="isDownloading">
          <i class="fa fa-download me-2"></i>{{isDownloading ? 'Downloading PDF...' : 'Download PDF'}}
        </a>
        <a (click)="printAsPdf($event)" style="margin-left: 10px;" [class.disabled]="isPrinting">
          <i class="fa fa-print me-2"></i>{{isPrinting ? 'Printing PDF...' : 'Print PDF'}}
        </a>
        <a (click)="sendStatementEmail($event)" style="margin-left: 10px;" [class.disabled]="isSendingEmail">
          <i class="fa fa-envelope me-2"></i>{{isSendingEmail ? 'Sending Email...' : 'Send Email'}}
        </a>
      </div>
    </div>
  </div>
  <!-- Reusable Templates to avoid code duplication -->
  <ng-template #summaryRowsTemplate>
    <div class="row-data">
      <span>Starting Balance</span>
      <span>{{summaryStartingBalance | statementAmount}}</span>
    </div>
    <div class="row-data">
      <span>Rents</span>
      <span>{{summaryRents | statementAmount}}</span>
    </div>
    <!-- <div class="row-data">
    <span>Paid Nights</span>
    <span>{{summaryPaidNights || 0}}</span>
  </div> -->
  <!-- <div class="row-data">
  <span>Guest Nights</span>
  <span>{{summaryGuestNights || 0}}</span>
</div>
<div class="row-data">
  <span>Owner Nights</span>
  <span>{{summaryOwnerNights || 0}}</span>
</div>
<div class="row-data">
  <span>Owner Guest Nights</span>
  <span>{{summaryOwnerGuestNights || 0}}</span>
</div>
<div class="row-data">
  <span>Maintenance Nights</span>
  <span>{{summaryMaintenanceNights || 0}}</span>
</div> -->
<!-- <div class="row-data">
<span>Occupancy Rate</span>
<span>{{summaryOccupancyRate || 0}}%</span>
</div> -->
<div class="row-data muted">
  <span (click)="openTaxBreakdownDialog('revenue')" style="cursor: pointer;">
    Tax
    <i class="info-icon pi pi-info-circle ms-1" title="View Tax Breakdown"></i>
  </span>
  <span>{{summaryTaxRevenue | statementAmount}}</span>
</div>
<div class="row-data">
  <span>Housekeeping Credit</span>
  <span>{{summaryHousekeepingCredit | statementAmount}}</span>
</div>
<div class="row-data">
  <span>Maintenance Credit</span>
  <span>{{summaryMaintenanceCredit | statementAmount}}</span>
</div>
<div class="row-data revenue-row mb-4">
  <span><strong>Total Revenue</strong></span>
  <span><strong>{{summarySubtotalCredits | statementAmount}}</strong></span>
</div>
<div class="row-data muted">
  <span>Housekeeping</span>
  <span>{{summaryHousekeepingDebit | statementAmount}}</span>
</div>
<div class="row-data muted">
  <span>Maintenance</span>
  <span>{{summaryMaintenanceDebit | statementAmount}}</span>
</div>
<div class="row-data muted">
  <span>Management</span>
  <span>{{summaryManagementDebit | statementAmount}}</span>
</div>
<div class="row-data muted">
  <span (click)="openTaxBreakdownDialog('expense')" style="cursor: pointer;">
    Tax Paid On Your Behalf
    <i class="info-icon pi pi-info-circle ms-1" title="View Tax Expense Breakdown"></i>
  </span>
  <span>{{summaryTaxPaidDebit | statementAmount}}</span>
</div>
<div class="row-data total-expenses  mb-4">
  <span>Total Expenses</span>
  <span>{{summarySubtotalDebits | statementAmount}}</span>
</div>
<div class="row-data net  mb-4">
  <span>Net Proceeds</span>
  <span>{{summaryNetProceeds | statementAmount}}</span>
</div>
<div class="row-data muted">
  <span>Payment To Owner</span>
  <span>{{summaryPaymentToOwner | statementAmount}}</span>
</div>
<div class="row-data muted">
  <span>Ending Balance</span>
  <span>{{summaryEndingBalance | statementAmount}}</span>
</div>
</ng-template>

<ng-template #benefitsContentTemplate>
  <div class="main-heading">
    <strong>HOMEOWNER BENEFITS - {{ownerStmtOjb?.stmtYear}}</strong>
  </div>
  <div class="d-flex gap-4 justify-content-between benefits-container flex-wrap">
    @if (ownerStmtOjb?.freeDepartureCleanNUM > 0) {
      <div>
        <div>Complimentary Housekeepings</div>
        <div class="fw-bold">{{ownerStmtOjb?.usedFreeDepartureCleanNUM || 0}} used ·
        {{ownerStmtOjb?.freeDepartureCleanNUM || 0}} allotted</div>
      </div>
    }
    @if (ownerStmtOjb?.freeCarDaysNUM > 0) {
      <div>
        <div>Complimentary Rental Car Days</div>
        <div class="fw-bold">{{ownerStmtOjb?.usedFreeCarDaysNUM || 0}} used · {{ownerStmtOjb?.freeCarDaysNUM ||
        0}} allotted</div>
      </div>
    }
    <div>
      <div>Complimentary Maintenance</div>
      <div class="fw-bold">{{getValueByMonth('YTD', 'maintenanceCreditTotal') | statementAmount}}
      </div>
    </div>
    @if (!(ownerStmtOjb?.freeCarDaysNUM > 0)) {
      <div></div>
    }
    <div>
      <div>Owner Nights</div>
      <div class="fw-bold">{{getValueByMonth('YTD', 'ownerNights')}}
      </div>
    </div>
    <div>
      <div>Owner Guest Nights</div>
      <div class="fw-bold">{{getValueByMonth('YTD', 'ownerGuestNights')}}
      </div>
    </div>
  </div>
</ng-template>

<!-- Content Layout: Letter + Benefits (left), Summary (right) -->
<div class="owner-content-grid">
  <div class="content-grid-col left-column">
    <!-- Owner Notes: memo style with orange left border and NOTES label -->


    <div class="summary-card p-3 letter-section">
      <!-- <span class="blog-badge badge-light rounded-4 px-3">BLOG</span> -->
      <div class="owner-notes-wrapper mb-3">
        <!-- <div class="owner-notes-header">
        <i class="pi pi-file owner-notes-icon" aria-hidden="true"></i>
        <span class="owner-notes-label">NOTES</span>
      </div> -->
      <div class="owner-notes-content">
        {{ownerStmtOjb?.ownerNotes}}
      </div>
    </div>

    <div class="customer-desc">
      <div #contentContainer class="content-display-container" [innerHTML]="safeDisplayContent"></div>
      @if (showViewCompleteLink) {
        <p class="view-complete-link">
          <a (click)="openCompleteLetterDialog(); $event.preventDefault()"
          style="color: #06465B; text-decoration: underline; cursor: pointer;">Read More</a>
        </p>
      }
    </div>
  </div>

  <div class="summary-card mt-2 p-3 benefits-section">
    <ng-container *ngTemplateOutlet="benefitsContentTemplate"></ng-container>
  </div>
</div>

<div class="content-grid-col right-column">

  <div class="summary-card p-3 mb-3 mb-md-0">
    <div class="main-heading mb-2">
      <strong>SUMMARY</strong>
    </div>
    <div class="summary-rows-wrap">
      <ng-container *ngTemplateOutlet="summaryRowsTemplate"></ng-container>
    </div>
  </div>
</div>
</div>
</div>
<div class="owner-stmt-tables-stack">
  <!-- reservationsSummaries -->
  <div class="my-2 datatable Stmt-reservation-summary table-box-wrap py-2 px-0 border-0">
    <div class="table-responsive">
      <div class="table-main-heading">
        <strong>RESERVATIONS</strong>
      </div>
      <p-table [value]="ownerStmtOjb?.reservationsSummaries" class="table datatable-table">
        <ng-template pTemplate="header">
          <tr class="text-center">
            <th colspan="5"></th>
            <th class="text-center" colspan="4">Revenue</th>
            <th class="text-center" colspan="2">Expense</th>
            <th class="tr-last-td" colspan="3"></th>
          </tr>

          <tr>
            <th class="text-center">Res #</th>
            <th class="text-center">Status</th>
            <th class="text-center">Name</th>
            <th class="text-center">From</th>
            <th class="text-center">To</th>
            <th class="text-center">Nights</th>
            <th class="text-center">Avg Daily Rent</th>
            <th class="text-center">Rents</th>
            <th class="text-center">Tax</th>
            <th class="text-center">Mgmt.</th>
            <th class="text-center">Tax</th>
            <th class="text-center">Net Rents</th>
            <th class="text-center"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ownerRez let-index="rowIndex">
          <tr>
            <td class="text-start">
              <div class="d-inline-flex align-items-center gap-1">
                @if (!openingReservation[ownerRez.reservationId]) {
                  <span (click)="openReservation(ownerRez,$event)"
                    class="cursor-pointer link-text">
                    {{ownerRez.reservationId}}
                  </span>
                }
                @if (openingReservation[ownerRez.reservationId]) {
                  <span>
                    <i class="pi pi-spinner pi-spin"></i>
                  </span>
                }
              </div>
            </td>
            <td class="text-start">{{ getReservationStatus(ownerRez.reservationStatus) }}</td>
            <td class="text-start">{{ ownerRez.guestName }}</td>
            <td class="text-start">{{ ownerRez.checkInDate | date }}</td>
            <td class="text-start">{{ ownerRez.checkOutDate | date }}</td>
            <td class="text-center">{{ ownerRez.stmtNights }}</td>

            <td class="text-center">
              @if (ownerRez?.rents && ownerRez?.stmtNights) {
                <span>
                  {{ (ownerRez?.rents / ownerRez?.stmtNights) | statementAmount }}
                </span>
              }
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end text-end">
                <div>{{ ownerRez?.rents | statementAmount }}</div>
              </div>
            </td>

            <td class="text-end">
              <div class="d-flex justify-content-end text-end cursor-pointer"
                (click)="openReservationTaxBreakdown(ownerRez, $event)">
                <div>{{ ownerRez?.rentsTax | statementAmount }}</div>
                <div class="d-inline-flex align-items-center gap-1">
                  @if (ownerRez?.taxes?.length) {
                    <i class="pi pi-info-circle text-primary ms-1 cursor-pointer" style="font-size: 0.8rem;"
                      pTooltip="View tax breakdown" tooltipPosition="top">
                    </i>
                  }
                </div>
              </div>
            </td>

            <td class="text-end">
              <div class="d-flex justify-content-end">
                <div>{{ ownerRez?.mgmt | statementAmount }}</div>
              </div>
            </td>

            <td class="text-end">
              <div class="d-flex justify-content-end">
                <div>{{ ownerRez?.mgmtTax | statementAmount }}</div>
              </div>
            </td>

            <td>{{ ownerRez?.netRents | statementAmount }}</td>

            <td class="tr-last-td">
              <a tooltip="View reservation ledger" tooltipPosition="top"
                (click)="viewReservationLedger(ownerRez.reservationId); $event.stopPropagation()"
                style="cursor: pointer;">
                <i style="color: blue;" class="pi pi-info-circle"></i>
              </a>
            </td>
          </tr>

          @if (ownerStmtOjb?.reservationsSummaries.length - 1 == index) {
            <tr>
              <td colspan="5"></td>
              <td class="text-center">
                <strong>{{ getResSummStmtNights() }}</strong>
              </td>
              <td class="text-end">
                <strong></strong>
              </td>
              <td class="text-end">
                <strong>{{ ownerStmtOjb?.revenueTotal | statementAmount }}</strong>
              </td>
              <td class="text-end">
                <strong>{{ ownerStmtOjb?.revenueTaxTotal | statementAmount }}</strong>
              </td>
              <td class="text-end">
                <strong>{{ ownerStmtOjb?.mgmtTotal | statementAmount }}</strong>
              </td>
              <td class="text-end">
                <strong>{{ ownerStmtOjb?.mgmtTaxTotal | statementAmount }}</strong>
              </td>
              <td class="tr-last-td">
                <strong>{{ ownerStmtOjb?.netRentTotal | statementAmount }}</strong>
              </td>
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- expenseSummaries -->

  @if (expenseLoading) {
    <div class="kbm-search-loading">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"></p-progressSpinner>
      <div class="mt-2 mb-0 text-white">Opening Expense...</div>
    </div>
  }

  <div class="my-2 datatable Stmt-expense-summary table-box-wrap border-0 py-2 px-0">
    <div class="table-responsive">
      <div class="table-main-heading">
        <strong>EXPENSES</strong>
      </div>

      <p-table [value]="ownerStmtOjb?.expenseSummaries" class="table datatable-table">
        <ng-template pTemplate="header">
          <tr class="text-center">
            <th class="text-center" style="width: 130px">Date</th>
            <th class="text-center" style="width: 150px">Type</th>
            <th class="text-center" style="min-width: 250px;">Description</th>
            <th style="width: 150px">Amount Paid By<br>KBM Resorts</th>
            <th style="width: 150px">Amount Paid By<br>Homeowner</th>
            <th class="tr-last-td"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ownerExp let-index="rowIndex">
          <tr>
            <td>{{ ownerExp.expenseDate | date }}</td>
            <td class="text-start"> {{ getExpenseTypeName(ownerExp) }} </td>
            <td class="text-start">
              <div class="expense-title">{{ ownerExp.title }}</div>
              <div class="expense-description">{{ ownerExp.description }}</div>
            </td>

            <td class="text-end">
              <div class="d-flex justify-content-end text-end">
                <div>{{ ownerExp?.amountPaidByKBM | statementAmount }}</div>
              </div>
            </td>

            <td class="text-end">
              <div class="d-flex justify-content-end text-end">
                <div>{{ ownerExp?.amountPaidByOwner | statementAmount }}</div>
              </div>
            </td>
            <td class="tr-last-td">
              <div class="d-flex justify-content-center align-items-center">
                <a (click)="openExpenseEdit(ownerExp); $event.stopPropagation()" style="cursor: pointer;">
                  <i style="color: blue;" class="pi pi-pencil"></i>
                </a>
              </div>
            </td>
          </tr>

          @if (ownerStmtOjb?.expenseSummaries.length - 1 == index) {
            <tr>
              <td colspan="3"></td>
              <td class="text-end">
                <strong>{{
                  ownerStmtOjb?.totalExpAmountPaidByKBM | statementAmount
                }}</strong>
              </td>
              <td class="text-end">
                <strong>{{
                  ownerStmtOjb?.totalExpAmountPaidByOwner | statementAmount
                }}</strong>
              </td>
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- stmtSummaries -->


  <div class="my-2 datatable Stmt-year-To-Date table-box-wrap py-2 px-0 border-0">
    <div class="table-main-heading Stmt-year-To-Date-heading">
      <strong>YEAR TO DATE</strong>
    </div>
    <div class="Stmt-year-To-Date-scroll">
      <div class="table-responsive p-datatable">
        @if (ownerStmtOjb) {
          <table class="table datatable-table">
            <thead class="datatable-header text-center p-datatable-thead">
              <!-- <tr>
              <th class="table-main-heading" colspan="14"><strong>YEAR TO DATE</strong></th>
            </tr> -->
            <tr>
              <th [ngStyle]="{ width: 'fit-content' }"></th>
              @for (month of months; track month) {
                <th class="text-center">{{ month | slice : 0 : 3 }}</th>
              }
              <!-- <th>YTD</th> -->
            </tr>
          </thead>
          <tbody class="datatable-body p-datatable-tbody">
            @for (row of tableRows; track row) {
              <tr [ngClass]="{ 
                    'statement-row-gap': row.field === 'empty',
                    'total-net-proceeds-row': row.field === 'totalNetProceed',
                    'payment-to-owner-row': row.field === 'paymentToOwner',
                    'total-revenue-row': row.field === 'totalRevenueWithExpenseCredit',
                    'fw-none': row.field === 'endingBalance',
                    'total-expense-row': row.field === 'totalExpenseWithExpenseCredit'
                  }">
                <td>{{ row.field === 'empty' ? '' : row.label }}</td>
                @for (month of months; track month) {
                  <td>
                    @if (row.field !== 'empty') {
                      {{ ['paidNights', 'occupancyRate', 'guestNight', 'ownerNights',
                      'maintenanceNights','ownerGuestNights'].includes(row.field) ? getValueByMonth(month, row.field) :
                      (getValueByMonth(month, row.field) | statementAmount) }}
                      {{ row.field === 'occupancyRate' ? "%" : "" }}
                    }
                  </td>
                }
                <!-- <td>{{ getYearToDateTotal(row.field) | statementAmount }}</td> -->
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
</div>
</div>


<p-dialog appendTo="body" maskStyleClass="owner-stmt-tax-primeng-mask" styleClass="owner-stmt-tax-primeng-panel"
  [baseZIndex]="1100" [header]="taxBreakdownTitle" [(visible)]="showTaxBreakdownDialog"
  [modal]="true" [style]="{ width: '600px' }" [breakpoints]="{ '960px': '80vw', '640px': '90vw' }" [draggable]="false"
  [resizable]="false">
  <div class="tax-breakdown-content">
    @if (taxBreakdownData.length === 0) {
      <p class="text-muted mb-0">No tax breakdown data available.</p>
    }
    @if (taxBreakdownData.length > 0) {
      <p-table [value]="taxBreakdownData" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: left; padding: 8px;">Tax Name</th>
            <th style="text-align: right; padding: 8px;">Tax Amount</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tax>
          <tr>
            <td style="padding: 8px;">{{tax.name || '-'}}</td>
            <td style="padding: 8px; text-align: right;">
              {{tax.amount | statementAmount}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr style="background-color: #f8f9fa; font-weight: 600;">
            <td style="padding: 8px; text-align: right;">Total:</td>
            <td style="padding: 8px; text-align: right;">
              {{getTotalTaxAmount() | statementAmount}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="2" class="text-center text-muted">No items</td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</p-dialog>